// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"g-Pmd0OFtwwRfzOvHjM_m","dialog":"_3Fgy3ZMkj9y1-ZzeiaQ8Ks","content":"_2Wj8nsyCrC0HcjizGIFphV","headerWrapper":"US2aEDPqrHkfoSrXiMR5d"};